import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-not-invited-members',
  templateUrl: './not-invited-members.component.html',
  styleUrls: ['./not-invited-members.component.css']
})
export class NotInvitedMembersComponent implements OnInit {

  @Input() NoOfNotInvitedMembers: number;;
  @Input() active: boolean;
  @Output() filterProgramsEvent = new EventEmitter();
  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/not-invited-members/not-invited-members.component.ts